import React, { useState } from 'react';
import "./NewRecepisse.scss";
import Footer from '../../components/Footer/Footer';
import { useNavigate } from 'react-router';
import { useRecoilState, useRecoilValue } from 'recoil';
import { RecoilloadState, UserInfoStateRecoil } from '../../utilities/globaleState';
import { useForm ,SubmitHandler } from 'react-hook-form';
import API from '../../utilities/API';
import Erreurs from '../../components/Erreurs/Erreurs';
import Swal from 'sweetalert2';

// Fonction pour formater les erreurs de l'API vers le format attendu par le composant Erreurs
const formatApiErrors = (apiErrors: any): any[] => {

  if (!apiErrors) {
    return ['Une erreur est survenue'];
  }

  // Si c'est un objet unique, le transformer en array
  if (!Array.isArray(apiErrors)) {
    apiErrors = [apiErrors];
  }

  // Transformer chaque erreur pour qu'elle ait la propriété 'messages'
  return apiErrors.map((error: any) => {
    if (typeof error === 'string') {
      return { messages: error };
    }
    // Assurer que l'erreur a une propriété 'messages'
    return {
      ...error,
      messages: error.messages || error.msg || 'Erreur inconnue'
    };
  });
};

interface Recepisse {
  paiementNumber: string;
}

function NewRecepisse() {
  const navigate = useNavigate();  

  // const [ userInfoState , setUserInfoState ] = useRecoilState(UserInfoStateRecoil);
  const user = useRecoilValue(UserInfoStateRecoil);
  const [recepisseInfo,setRecepisseInfo ] = useState<Recepisse >({paiementNumber:''});
  const [erreurs, setErreurs] = useState<any[]>([]);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Recepisse>();

  const api = new API();
  const [ isLoading,setIsLoading ] = useRecoilState(RecoilloadState);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if(erreurs.length > 0){
      setErreurs([]);
    }
    setRecepisseInfo({...recepisseInfo,[e.target.name] : e.target.value?.toUpperCase()})
   }
   const handleSubmitForm :SubmitHandler<Recepisse> = async (data) => {
    setErreurs([]);setIsLoading(true);
   try{ 
    
    const resp =  await api.apiData("get",`recepisse/isPrinted/${data?.paiementNumber}`);
    
    // if( resp.status === 200 ){
    //   // Transformer le format d'erreur de l'API vers le format attendu par Erreurs
    //   const formattedErrors = formatApiErrors(resp.messages);
    //   setErreurs((prev:any) => [...prev, ...formattedErrors]);
    //   console.log(erreurs);
    //   setIsLoading(false); // Arrêter le chargement en cas d'erreur
    //   return; // Important : arrêter l'exécution pour que les erreurs s'affichent
    //  }
    
      if( resp?.recepisseInfo ){
        Swal.fire({
              title: "Êtes-vous sûr?",
              text: "Ce récépissé a été déjà imprimé.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: `Oui`,
              cancelButtonText: "Non",
          }).then((result) => {
          
              if (result.isConfirmed) {
              
              api.apiData("post","recepisse/nouvelle",data).then((resp) => {
                //console.log(resp);
                if( resp.status !== 200 ){
          
                  // Transformer le format d'erreur de l'API vers le format attendu par Erreurs
                  const formattedErrors = formatApiErrors(resp.errors);
                  console.log(formattedErrors);
                  setErreurs(formattedErrors);
                  setIsLoading(false); // Arrêter le chargement en cas d'erreur
                  return; // Important : arrêter l'exécution pour que les erreurs s'affichent
                }
                else{
                  navigate(`/recepissedetails/${resp.RecepInfo.paiementNumber}`)
                }
              })
            
              }})
      } 
      else{
          const resp1 = await api.apiData("post","recepisse/nouvelle",data);
          if( resp1.status !== 200 ){
              // Transformer le format d'erreur de l'API vers le format attendu par Erreurs
              const formattedErrors = formatApiErrors(resp1.errors);
              setErreurs(formattedErrors);
          }
          else{
            navigate(`/recepissedetails/${resp1.RecepInfo.paiementNumber}`)
          }
      }
   }
    catch(error){
        console.log(errors);
    }
    finally{
      setIsLoading(false);
    }
   
   }  
 // console.log(erreurs) 
  return (
    <div className='recepisse'>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
       <div className='recepisse__header'>
          <h2>Nouveau Récépissé</h2>
          <p>Saisir le numéro de paiement pour générer le récépissé</p>
       </div>
       <Erreurs validation={erreurs} />
        <div className='recepisse__input-group'>
            <div className='recepisse__input-group__label'>
                N°Paiement
            </div>
            <div className='recepisse__input-group__input-value'>
                <input type='text' placeholder='Saisir le numéro de paiement'
                 value = {recepisseInfo?.paiementNumber}  
                 {...register('paiementNumber', {
                  onChange: (e) => {
                       handleInput(e)
                  },
                required:true,minLength:3,maxLength:30},
              )}
                />
            </div>
            {errors.paiementNumber && errors.paiementNumber?.type === "required" && (
            <span className="error-msg">Le numero de paiement est obligatoire.</span>
            )}
            {errors.paiementNumber && errors.paiementNumber?.type === "minLength" && (
              <span className="error-msg">Le minimum de caractère est trois (3).</span>
            )}
            {errors.paiementNumber && errors.paiementNumber?.type === "maxLength" && (
              <span className="error-msg">Le caractère maximum est trente (30).</span>
            )}
        </div>
        <div className='recepisse__button'>
            <button type='submit' className={`${isLoading? 'no-pointer':''}`} disabled={isLoading}>{!isLoading ? "Valider":"Patientez.."}</button>
        </div>
       </form>   
    </div>
  )
}

export default NewRecepisse